import React, { ReactElement } from "react";

interface TabPaneInterface {
   children?: React.ReactNode;
   tab?: ReactElement | string;
   updateCasesList?: (profileId: number) => void;
   profileId?: number;
}
const TabPane: React.FC<TabPaneInterface> = ({ children }) => {
   return (
      <>
         <div>{children}</div>
      </>
   );
};

export default TabPane;
